import { type RefObject, useEffect } from "react";

/** Scroll `ref.current` into view whenever `active` flips to a truthy value, and
 *  optionally fire `onDone` immediately after. Used by group-row components to handle
 *  both the "newly-created group" autoscroll and the post-add-docs `scrollTo` signal. */
export function useScrollIntoViewWhen(
  ref: RefObject<HTMLElement | null>,
  active: boolean | undefined,
  onDone?: () => void,
) {
  useEffect(() => {
    if (!active || !ref.current) return;
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    onDone?.();
  }, [active, onDone, ref]);
}
